import {PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import LayerSelector from 'pipelines/generalized-step-config-editor/editors/custom-editors/LayerSelector';

import {StepTypeConfigUISchemaV2} from '../step-config-settings/StepConfigUISchemas';
import {
  CUSTOM_COMPONENT_KEY,
  FIELD_ORDER_UI_SCHEMA_KEY,
  REQUIRES_MANUAL_PREVIEW,
} from '../StepConfigEditorTypes';

export const PLATES_TO_DATASETS_V0_UI_SCHEMA: StepTypeConfigUISchemaV2<
  PipelineStepType.PLATES_TO_DATASETS,
  0
> = {
  [FIELD_ORDER_UI_SCHEMA_KEY]: ['layers'],
  [REQUIRES_MANUAL_PREVIEW]: true,
  layers: {
    [FIELD_ORDER_UI_SCHEMA_KEY]: ['layers'],
    layers: {
      [CUSTOM_COMPONENT_KEY]: LayerSelector,
    },
  },
};
